import { supabase } from '../lib/supabase';
interface SitemapEntry {
  loc: string;
  lastmod?: string;
  changefreq?: 'always' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | 'never';
  priority?: number;
}

// Cache sitemap for 1 hour
let sitemapCache: {
  content: string;
  timestamp: number;
} | null = null;

const CACHE_DURATION = 60 * 60 * 1000; // 1 hour in milliseconds

export async function generateSitemapIndex(): Promise<string> {
  try {
    // Check cache first
    // Generate new sitemap
    // Generate sitemap files first
    await supabase.rpc('generate_sitemap_files');
    
    // Get sitemap index
    const { data: indexData, error: indexError } = await supabase.rpc('generate_sitemap_index');
    
    if (indexError) {
      console.error('Error generating sitemap:', indexError);
      throw indexError;
    }

    return indexData;
  } catch (error) {
    console.error('Error generating sitemap index:', error);
    throw error;
  }
}

export async function getSitemapFile(filename: string): Promise<string> {
  try {
    const { data, error } = await supabase.rpc('get_sitemap_file', { input_filename: filename });

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error getting sitemap file:', error);
    throw error;
  }
}